import { __awaiter, __decorate, __generator } from "tslib";
import { observable, makeObservable } from 'mobx';
import { generateUUID } from '../../Index';
import { ComplaintRepo } from '../../Repositories/ComplaintRepo';
var newInputObject = {
    value: '',
    label: '',
};
var ComplaintStore = /** @class */ (function () {
    function ComplaintStore(rootStore) {
        var _this = this;
        Object.defineProperty(this, "ucfStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "complaintFilter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                searchKey: '',
                pageSize: 10,
                currentPage: 1,
            }
        });
        Object.defineProperty(this, "complaintList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "complaintDetail", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "customerInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                value: '',
                label: '',
            }
        });
        Object.defineProperty(this, "brandInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                value: '',
                label: '',
            }
        });
        Object.defineProperty(this, "packagingInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                value: '',
                label: '',
            }
        });
        Object.defineProperty(this, "dischargeInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                value: '',
                label: '',
            }
        });
        Object.defineProperty(this, "modelInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                value: '',
                label: '',
            }
        });
        Object.defineProperty(this, "conformanceInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                value: '',
                label: '',
            }
        });
        Object.defineProperty(this, "mediaInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                value: '',
                label: '',
            }
        });
        Object.defineProperty(this, "enclosedInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                value: '',
                label: '',
            }
        });
        Object.defineProperty(this, "salesEmailInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                value: '',
                label: '',
            }
        });
        Object.defineProperty(this, "complaintTimeline", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                planDetail: [],
                actualDetail: [],
            }
        });
        Object.defineProperty(this, "existingAttachment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "initComplaintInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.complaintDetail = {
                    id: '',
                    distributedToInternal: null,
                    receivedDate: null,
                    reportedDate: null,
                    customerId: '',
                    customerName: '',
                    address: '',
                    pic: '',
                    email: '',
                    phone: '',
                    brandId: '',
                    brandName: '',
                    productId: '',
                    productName: '',
                    plantId: '',
                    plantName: '',
                    packagingId: '',
                    packagingName: '',
                    blDate: null,
                    dispatchDate: null,
                    dischargePortId: '',
                    dischargePortName: '',
                    countryId: '',
                    countryName: '',
                    containerNo: '',
                    modelOfDeliveryId: '',
                    modelOfDeliveryName: '',
                    conformanceTypeId: '',
                    conformanceTypeName: '',
                    complaintMediaId: '',
                    complaintMediaName: '',
                    enclosedId: '',
                    enclosedName: '',
                    salesMemberId: '',
                    salesMemberName: '',
                    description: '',
                    createdBy: '',
                    updatedBy: '',
                    status: '',
                    ccSalesAttachment: '',
                    ccAreaOwnerAttachment: '',
                    customerComplaintDetail: [],
                    customerComplaintQuestion: [],
                    feedback: '',
                    emailTo: '',
                };
                _this.brandInput = newInputObject;
                _this.mediaInput = newInputObject;
                _this.modelInput = newInputObject;
                _this.packagingInput = newInputObject;
                _this.customerInput = newInputObject;
                _this.enclosedInput = newInputObject;
                _this.conformanceInput = newInputObject;
                _this.dischargeInput = newInputObject;
                _this.salesEmailInput = newInputObject;
            }
        });
        makeObservable(this);
        this.ucfStore = rootStore;
        this.initComplaintInput();
    }
    Object.defineProperty(ComplaintStore.prototype, "initComplaintDetailInput", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return {
                id: generateUUID(),
                customerComplaintId: '',
                po: '',
                so: '',
                batch: '',
                qty: 0,
            };
        }
    });
    Object.defineProperty(ComplaintStore.prototype, "getComplaintList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var complaintList;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintRepo.getComplaintList(this.ucfStore, this.complaintFilter)];
                        case 1:
                            complaintList = _a.sent();
                            this.complaintList = complaintList;
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintStore.prototype, "getComplaintDetail", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var complaint;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintRepo.getComplaintDetail(this.ucfStore, id)];
                        case 1:
                            complaint = _a.sent();
                            if (complaint) {
                                this.complaintDetail = complaint;
                                this.ucfStore.complaintSupport.setSelectedBrand(complaint.brandId);
                                this.ucfStore.complaintSupport.setSelectedCustomer(complaint.customerId);
                                this.ucfStore.complaintSupport.setSelectedPackaging(complaint.packagingId);
                                this.ucfStore.complaintSupport.setSelectedDischarge(complaint.dischargePortId);
                                this.ucfStore.complaintSupport.setSelectedModel(complaint.modelOfDeliveryId);
                                this.ucfStore.complaintSupport.setSelectedMedia(complaint.complaintMediaId);
                                this.ucfStore.complaintSupport.setSelectedEnclosed(complaint.enclosedId);
                                this.ucfStore.complaintSupport.setSelectedConformance(complaint.conformanceTypeId, true);
                                this.ucfStore.complaintSupport.setSelectedSales(complaint.salesMemberId);
                                this.existingAttachment = complaint.ccSalesAttachment !== '';
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintStore.prototype, "createComplaint", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var complaint;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintRepo.createComplaint(this.ucfStore, this.complaintDetail)];
                        case 1:
                            complaint = _a.sent();
                            if (complaint) {
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/, false];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintStore.prototype, "updateComplaint", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var complaint;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintRepo.updateComplaint(this.ucfStore, id, this.complaintDetail)];
                        case 1:
                            complaint = _a.sent();
                            if (complaint) {
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/, false];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintStore.prototype, "getComplaintTimeline", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var timeline;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintRepo.getComplaintTimeline(this.ucfStore, id)];
                        case 1:
                            timeline = _a.sent();
                            this.complaintTimeline = timeline;
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintStore.prototype, "uploadComplaintFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            return __awaiter(this, void 0, void 0, function () {
                var file;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintRepo.uploadComplaintFile(this.ucfStore, data)];
                        case 1:
                            file = _a.sent();
                            return [2 /*return*/, file];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintStore.prototype, "approveComplaint", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var approve;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintRepo.approveComplaint(this.ucfStore, this.complaintDetail.id, { feedback: this.complaintDetail.feedback })];
                        case 1:
                            approve = _a.sent();
                            if (approve) {
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/, false];
                    }
                });
            });
        }
    });
    Object.defineProperty(ComplaintStore.prototype, "rejectComplaint", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var reject;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ComplaintRepo.rejectComplaint(this.ucfStore, this.complaintDetail.id, { feedback: this.complaintDetail.feedback })];
                        case 1:
                            reject = _a.sent();
                            if (reject) {
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/, false];
                    }
                });
            });
        }
    });
    __decorate([
        observable
    ], ComplaintStore.prototype, "ucfStore", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "complaintFilter", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "complaintList", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "complaintDetail", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "customerInput", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "brandInput", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "packagingInput", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "dischargeInput", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "modelInput", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "conformanceInput", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "mediaInput", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "enclosedInput", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "salesEmailInput", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "complaintTimeline", void 0);
    __decorate([
        observable
    ], ComplaintStore.prototype, "existingAttachment", void 0);
    return ComplaintStore;
}());
export { ComplaintStore };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29tcGxhaW50U3RvcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU3RvcmUvQ29tcGxhaW50L0NvbXBsYWludFN0b3JlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUMsVUFBVSxFQUFFLGNBQWMsRUFBQyxNQUFNLE1BQU0sQ0FBQztBQUNoRCxPQUFPLEVBQUMsWUFBWSxFQUFDLE1BQU0sYUFBYSxDQUFDO0FBR3pDLE9BQU8sRUFBQyxhQUFhLEVBQUMsTUFBTSxrQ0FBa0MsQ0FBQztBQUcvRCxJQUFNLGNBQWMsR0FBRztJQUNyQixLQUFLLEVBQUUsRUFBRTtJQUNULEtBQUssRUFBRSxFQUFFO0NBQ1YsQ0FBQztBQUVGO0lBZ0VFLHdCQUFZLFNBQW1CO1FBQS9CLGlCQUlDO1FBbkVXOzs7OztXQUFtQjtRQUVuQjs7OzttQkFBK0I7Z0JBQ3pDLFNBQVMsRUFBRSxFQUFFO2dCQUNiLFFBQVEsRUFBRSxFQUFFO2dCQUNaLFdBQVcsRUFBRSxDQUFDO2FBQ2Y7V0FBQztRQUVVOzs7O21CQUEwQyxFQUFFO1dBQUM7UUFDN0M7Ozs7O1dBQW9DO1FBRXBDOzs7O21CQUFnQjtnQkFDMUIsS0FBSyxFQUFFLEVBQUU7Z0JBQ1QsS0FBSyxFQUFFLEVBQUU7YUFDVjtXQUFDO1FBRVU7Ozs7bUJBQWE7Z0JBQ3ZCLEtBQUssRUFBRSxFQUFFO2dCQUNULEtBQUssRUFBRSxFQUFFO2FBQ1Y7V0FBQztRQUVVOzs7O21CQUFpQjtnQkFDM0IsS0FBSyxFQUFFLEVBQUU7Z0JBQ1QsS0FBSyxFQUFFLEVBQUU7YUFDVjtXQUFDO1FBRVU7Ozs7bUJBQWlCO2dCQUMzQixLQUFLLEVBQUUsRUFBRTtnQkFDVCxLQUFLLEVBQUUsRUFBRTthQUNWO1dBQUM7UUFFVTs7OzttQkFBYTtnQkFDdkIsS0FBSyxFQUFFLEVBQUU7Z0JBQ1QsS0FBSyxFQUFFLEVBQUU7YUFDVjtXQUFDO1FBRVU7Ozs7bUJBQW1CO2dCQUM3QixLQUFLLEVBQUUsRUFBRTtnQkFDVCxLQUFLLEVBQUUsRUFBRTthQUNWO1dBQUM7UUFFVTs7OzttQkFBYTtnQkFDdkIsS0FBSyxFQUFFLEVBQUU7Z0JBQ1QsS0FBSyxFQUFFLEVBQUU7YUFDVjtXQUFDO1FBRVU7Ozs7bUJBQWdCO2dCQUMxQixLQUFLLEVBQUUsRUFBRTtnQkFDVCxLQUFLLEVBQUUsRUFBRTthQUNWO1dBQUM7UUFFVTs7OzttQkFBa0I7Z0JBQzVCLEtBQUssRUFBRSxFQUFFO2dCQUNULEtBQUssRUFBRSxFQUFFO2FBQ1Y7V0FBQztRQUVVOzs7O21CQUF3QztnQkFDbEQsVUFBVSxFQUFFLEVBQUU7Z0JBQ2QsWUFBWSxFQUFFLEVBQUU7YUFDakI7V0FBQztRQUVVOzs7O21CQUFxQixLQUFLO1dBQUM7UUFRdkM7Ozs7bUJBQXFCO2dCQUNuQixLQUFJLENBQUMsZUFBZSxHQUFHO29CQUNyQixFQUFFLEVBQUUsRUFBRTtvQkFDTixxQkFBcUIsRUFBRSxJQUFJO29CQUMzQixZQUFZLEVBQUUsSUFBSTtvQkFDbEIsWUFBWSxFQUFFLElBQUk7b0JBQ2xCLFVBQVUsRUFBRSxFQUFFO29CQUNkLFlBQVksRUFBRSxFQUFFO29CQUNoQixPQUFPLEVBQUUsRUFBRTtvQkFDWCxHQUFHLEVBQUUsRUFBRTtvQkFDUCxLQUFLLEVBQUUsRUFBRTtvQkFDVCxLQUFLLEVBQUUsRUFBRTtvQkFDVCxPQUFPLEVBQUUsRUFBRTtvQkFDWCxTQUFTLEVBQUUsRUFBRTtvQkFDYixTQUFTLEVBQUUsRUFBRTtvQkFDYixXQUFXLEVBQUUsRUFBRTtvQkFDZixPQUFPLEVBQUUsRUFBRTtvQkFDWCxTQUFTLEVBQUUsRUFBRTtvQkFDYixXQUFXLEVBQUUsRUFBRTtvQkFDZixhQUFhLEVBQUUsRUFBRTtvQkFDakIsTUFBTSxFQUFFLElBQUk7b0JBQ1osWUFBWSxFQUFFLElBQUk7b0JBQ2xCLGVBQWUsRUFBRSxFQUFFO29CQUNuQixpQkFBaUIsRUFBRSxFQUFFO29CQUNyQixTQUFTLEVBQUUsRUFBRTtvQkFDYixXQUFXLEVBQUUsRUFBRTtvQkFDZixXQUFXLEVBQUUsRUFBRTtvQkFDZixpQkFBaUIsRUFBRSxFQUFFO29CQUNyQixtQkFBbUIsRUFBRSxFQUFFO29CQUN2QixpQkFBaUIsRUFBRSxFQUFFO29CQUNyQixtQkFBbUIsRUFBRSxFQUFFO29CQUN2QixnQkFBZ0IsRUFBRSxFQUFFO29CQUNwQixrQkFBa0IsRUFBRSxFQUFFO29CQUN0QixVQUFVLEVBQUUsRUFBRTtvQkFDZCxZQUFZLEVBQUUsRUFBRTtvQkFDaEIsYUFBYSxFQUFFLEVBQUU7b0JBQ2pCLGVBQWUsRUFBRSxFQUFFO29CQUNuQixXQUFXLEVBQUUsRUFBRTtvQkFDZixTQUFTLEVBQUUsRUFBRTtvQkFDYixTQUFTLEVBQUUsRUFBRTtvQkFDYixNQUFNLEVBQUUsRUFBRTtvQkFDVixpQkFBaUIsRUFBRSxFQUFFO29CQUNyQixxQkFBcUIsRUFBRSxFQUFFO29CQUN6Qix1QkFBdUIsRUFBRSxFQUFFO29CQUMzQix5QkFBeUIsRUFBRSxFQUFFO29CQUM3QixRQUFRLEVBQUUsRUFBRTtvQkFDWixPQUFPLEVBQUUsRUFBRTtpQkFDWixDQUFDO2dCQUVGLEtBQUksQ0FBQyxVQUFVLEdBQUcsY0FBYyxDQUFDO2dCQUNqQyxLQUFJLENBQUMsVUFBVSxHQUFHLGNBQWMsQ0FBQztnQkFDakMsS0FBSSxDQUFDLFVBQVUsR0FBRyxjQUFjLENBQUM7Z0JBQ2pDLEtBQUksQ0FBQyxjQUFjLEdBQUcsY0FBYyxDQUFDO2dCQUNyQyxLQUFJLENBQUMsYUFBYSxHQUFHLGNBQWMsQ0FBQztnQkFDcEMsS0FBSSxDQUFDLGFBQWEsR0FBRyxjQUFjLENBQUM7Z0JBQ3BDLEtBQUksQ0FBQyxnQkFBZ0IsR0FBRyxjQUFjLENBQUM7Z0JBQ3ZDLEtBQUksQ0FBQyxjQUFjLEdBQUcsY0FBYyxDQUFDO2dCQUNyQyxLQUFJLENBQUMsZUFBZSxHQUFHLGNBQWMsQ0FBQztZQUN4QyxDQUFDO1dBQUM7UUEvREEsY0FBYyxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ3JCLElBQUksQ0FBQyxRQUFRLEdBQUcsU0FBUyxDQUFDO1FBQzFCLElBQUksQ0FBQyxrQkFBa0IsRUFBRSxDQUFDO0lBQzVCLENBQUM7Ozs7O2VBOEREO1lBQ0UsT0FBTztnQkFDTCxFQUFFLEVBQUUsWUFBWSxFQUFFO2dCQUNsQixtQkFBbUIsRUFBRSxFQUFFO2dCQUN2QixFQUFFLEVBQUUsRUFBRTtnQkFDTixFQUFFLEVBQUUsRUFBRTtnQkFDTixLQUFLLEVBQUUsRUFBRTtnQkFDVCxHQUFHLEVBQUUsQ0FBQzthQUNQLENBQUM7UUFDSixDQUFDOzs7Ozs7ZUFFRDs7Ozs7Z0NBQ3dCLHFCQUFNLGFBQWEsQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxlQUFlLENBQUMsRUFBQTs7NEJBQXpGLGFBQWEsR0FBRyxTQUF5RTs0QkFDL0YsSUFBSSxDQUFDLGFBQWEsR0FBRyxhQUFhLENBQUM7Ozs7O1NBQ3BDOzs7Ozs7ZUFFRCxVQUF5QixFQUFVOzs7OztnQ0FDZixxQkFBTSxhQUFhLENBQUMsa0JBQWtCLENBQUMsSUFBSSxDQUFDLFFBQVEsRUFBRSxFQUFFLENBQUMsRUFBQTs7NEJBQXJFLFNBQVMsR0FBRyxTQUF5RDs0QkFDM0UsSUFBSSxTQUFTLEVBQUU7Z0NBQ2IsSUFBSSxDQUFDLGVBQWUsR0FBRyxTQUFTLENBQUM7Z0NBRWpDLElBQUksQ0FBQyxRQUFRLENBQUMsZ0JBQWdCLENBQUMsZ0JBQWdCLENBQUMsU0FBUyxDQUFDLE9BQU8sQ0FBQyxDQUFDO2dDQUNuRSxJQUFJLENBQUMsUUFBUSxDQUFDLGdCQUFnQixDQUFDLG1CQUFtQixDQUFDLFNBQVMsQ0FBQyxVQUFVLENBQUMsQ0FBQztnQ0FDekUsSUFBSSxDQUFDLFFBQVEsQ0FBQyxnQkFBZ0IsQ0FBQyxvQkFBb0IsQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDLENBQUM7Z0NBQzNFLElBQUksQ0FBQyxRQUFRLENBQUMsZ0JBQWdCLENBQUMsb0JBQW9CLENBQUMsU0FBUyxDQUFDLGVBQWUsQ0FBQyxDQUFDO2dDQUMvRSxJQUFJLENBQUMsUUFBUSxDQUFDLGdCQUFnQixDQUFDLGdCQUFnQixDQUFDLFNBQVMsQ0FBQyxpQkFBaUIsQ0FBQyxDQUFDO2dDQUM3RSxJQUFJLENBQUMsUUFBUSxDQUFDLGdCQUFnQixDQUFDLGdCQUFnQixDQUFDLFNBQVMsQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFDO2dDQUM1RSxJQUFJLENBQUMsUUFBUSxDQUFDLGdCQUFnQixDQUFDLG1CQUFtQixDQUFDLFNBQVMsQ0FBQyxVQUFVLENBQUMsQ0FBQztnQ0FDekUsSUFBSSxDQUFDLFFBQVEsQ0FBQyxnQkFBZ0IsQ0FBQyxzQkFBc0IsQ0FBQyxTQUFTLENBQUMsaUJBQWlCLEVBQUUsSUFBSSxDQUFDLENBQUM7Z0NBQ3pGLElBQUksQ0FBQyxRQUFRLENBQUMsZ0JBQWdCLENBQUMsZ0JBQWdCLENBQUMsU0FBUyxDQUFDLGFBQWEsQ0FBQyxDQUFDO2dDQUV6RSxJQUFJLENBQUMsa0JBQWtCLEdBQUcsU0FBUyxDQUFDLGlCQUFpQixLQUFLLEVBQUUsQ0FBQzs2QkFDOUQ7Ozs7O1NBQ0Y7Ozs7OztlQUVEOzs7OztnQ0FDb0IscUJBQU0sYUFBYSxDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxlQUFlLENBQUMsRUFBQTs7NEJBQXBGLFNBQVMsR0FBRyxTQUF3RTs0QkFDMUYsSUFBSSxTQUFTLEVBQUU7Z0NBQ2Isc0JBQU8sSUFBSSxFQUFDOzZCQUNiOzRCQUNELHNCQUFPLEtBQUssRUFBQzs7OztTQUNkOzs7Ozs7ZUFFRCxVQUFzQixFQUFVOzs7OztnQ0FDWixxQkFBTSxhQUFhLENBQUMsZUFBZSxDQUFDLElBQUksQ0FBQyxRQUFRLEVBQUUsRUFBRSxFQUFFLElBQUksQ0FBQyxlQUFlLENBQUMsRUFBQTs7NEJBQXhGLFNBQVMsR0FBRyxTQUE0RTs0QkFDOUYsSUFBSSxTQUFTLEVBQUU7Z0NBQ2Isc0JBQU8sSUFBSSxFQUFDOzZCQUNiOzRCQUNELHNCQUFPLEtBQUssRUFBQzs7OztTQUNkOzs7Ozs7ZUFFRCxVQUEyQixFQUFVOzs7OztnQ0FDbEIscUJBQU0sYUFBYSxDQUFDLG9CQUFvQixDQUFDLElBQUksQ0FBQyxRQUFRLEVBQUUsRUFBRSxDQUFDLEVBQUE7OzRCQUF0RSxRQUFRLEdBQUcsU0FBMkQ7NEJBQzVFLElBQUksQ0FBQyxpQkFBaUIsR0FBRyxRQUFRLENBQUM7Ozs7O1NBQ25DOzs7Ozs7ZUFFRCxVQUEwQixJQUFTOzs7OztnQ0FDcEIscUJBQU0sYUFBYSxDQUFDLG1CQUFtQixDQUFDLElBQUksQ0FBQyxRQUFRLEVBQUUsSUFBSSxDQUFDLEVBQUE7OzRCQUFuRSxJQUFJLEdBQUcsU0FBNEQ7NEJBQ3pFLHNCQUFPLElBQUksRUFBQzs7OztTQUNiOzs7Ozs7ZUFFRDs7Ozs7Z0NBQ2tCLHFCQUFNLGFBQWEsQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxlQUFlLENBQUMsRUFBRSxFQUFFLEVBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxlQUFlLENBQUMsUUFBUSxFQUFDLENBQUMsRUFBQTs7NEJBQWpJLE9BQU8sR0FBRyxTQUF1SDs0QkFDdkksSUFBSSxPQUFPLEVBQUU7Z0NBQ1gsc0JBQU8sSUFBSSxFQUFDOzZCQUNiOzRCQUNELHNCQUFPLEtBQUssRUFBQzs7OztTQUNkOzs7Ozs7ZUFFRDs7Ozs7Z0NBQ2lCLHFCQUFNLGFBQWEsQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUFDLFFBQVEsRUFBRSxJQUFJLENBQUMsZUFBZSxDQUFDLEVBQUUsRUFBRSxFQUFDLFFBQVEsRUFBRSxJQUFJLENBQUMsZUFBZSxDQUFDLFFBQVEsRUFBQyxDQUFDLEVBQUE7OzRCQUEvSCxNQUFNLEdBQUcsU0FBc0g7NEJBQ3JJLElBQUksTUFBTSxFQUFFO2dDQUNWLHNCQUFPLElBQUksRUFBQzs2QkFDYjs0QkFDRCxzQkFBTyxLQUFLLEVBQUM7Ozs7U0FDZDs7SUE1TVc7UUFBWCxVQUFVO29EQUFvQjtJQUVuQjtRQUFYLFVBQVU7MkRBSVQ7SUFFVTtRQUFYLFVBQVU7eURBQThDO0lBQzdDO1FBQVgsVUFBVTsyREFBcUM7SUFFcEM7UUFBWCxVQUFVO3lEQUdUO0lBRVU7UUFBWCxVQUFVO3NEQUdUO0lBRVU7UUFBWCxVQUFVOzBEQUdUO0lBRVU7UUFBWCxVQUFVOzBEQUdUO0lBRVU7UUFBWCxVQUFVO3NEQUdUO0lBRVU7UUFBWCxVQUFVOzREQUdUO0lBRVU7UUFBWCxVQUFVO3NEQUdUO0lBRVU7UUFBWCxVQUFVO3lEQUdUO0lBRVU7UUFBWCxVQUFVOzJEQUdUO0lBRVU7UUFBWCxVQUFVOzZEQUdUO0lBRVU7UUFBWCxVQUFVOzhEQUE0QjtJQWdKekMscUJBQUM7Q0FBQSxBQTlNRCxJQThNQztTQTlNWSxjQUFjIn0=